module.exports = __webpack_public_path__ + "static/media/rub.d713903a.svg";